(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[57],{

/***/ 89594:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ _slug_; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./context/index.js + 6 modules
var context = __webpack_require__(64167);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./components/common/index.js + 82 modules
var common = __webpack_require__(35135);
// EXTERNAL MODULE: ./components/pages/index.js + 254 modules
var pages = __webpack_require__(4617);
// EXTERNAL MODULE: ./helpers/index.js + 6 modules
var helpers = __webpack_require__(69494);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
;// CONCATENATED MODULE: ./styles/pages/SingleInvestmentProjectStyle.js

var SingleInvestmentProjectStyle = styled_components_browser_esm/* default.div.attrs */.ZP.div.attrs({
  className: 'single-investment-project'
}).withConfig({
  componentId: "xlmrk8-0"
})([".single-invest{.top-container{display:flex;flex-direction:column;.back-to{display:flex;align-items:center;margin-bottom:var(--sp2x);transform:translateY(30vh);i{margin-right:var(--sp1-5x);}}.top{display:flex;flex-wrap:wrap;width:100%;>div{flex:0 0 50%;max-width:50%;}}}.catalog-view{.top{.comp-title{margin-bottom:0;}}}}@media screen and (max-width:", ") and (min-width:", "){.single-invest{margin-top:var(--sp4x);}}@media screen and (max-width:", "){.single-invest{.top-container{.back-to{margin-bottom:var(--sp1-5x);}.top{flex-direction:column;>div{flex:0 0 100%;max-width:100%;}}}}}"], function (props) {
  return props.theme.mediaQuery.DesktopSizeMMin;
}, function (props) {
  return props.theme.mediaQuery.DesktopSizeS;
}, function (props) {
  return props.theme.mediaQuery.DesktopSizeSMin;
});
/* harmony default export */ var pages_SingleInvestmentProjectStyle = (SingleInvestmentProjectStyle);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./pages/investment-projects/[slug]/index.js

var _excluded = ["pageParams", "global", "selectedLang", "winWidth", "isLoggedIn", "preloader"];
 //* HOC's


 //* Components


 //* Helpers

 //* Styles





var SingleInvestmentProjects = /*#__PURE__*/(0,react.memo)(function (_ref) {
  var _pageData$project, _pageData$project$met, _pageData$project2, _pageData$project2$me, _pageData$project3, _pageData$project3$me, _pageData$project4, _pageData$project5;

  var pageParams = _ref.pageParams,
      global = _ref.global,
      selectedLang = _ref.selectedLang,
      winWidth = _ref.winWidth,
      isLoggedIn = _ref.isLoggedIn,
      preloader = _ref.preloader,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  //! Router
  var router = (0,next_router.useRouter)(); //! Page Data

  var pageData = (0,react.useMemo)(function () {
    var _props$pageParams$sin, _props$pageParams$sin2;

    return (_props$pageParams$sin = props[pageParams.singleType]) === null || _props$pageParams$sin === void 0 ? void 0 : (_props$pageParams$sin2 = _props$pageParams$sin[router.query.slug]) === null || _props$pageParams$sin2 === void 0 ? void 0 : _props$pageParams$sin2[selectedLang];
  }, [props === null || props === void 0 ? void 0 : props[pageParams.singleType], router, selectedLang]); //! State

  var _useState = (0,react.useState)(),
      secObj = _useState[0],
      setSecObj = _useState[1]; //! Refs


  var TitleRef = (0,react.useRef)();
  var Ref1 = (0,react.useRef)();
  var Ref2 = (0,react.useRef)();
  var Ref3 = (0,react.useRef)();
  var Ref4 = (0,react.useRef)();
  var Ref5 = (0,react.useRef)();
  var Ref6 = (0,react.useRef)();
  var Ref7 = (0,react.useRef)();
  (0,react.useEffect)(function () {
    var _Ref1$current, _Ref3$current, _Ref1$current2, _Ref3$current2, _Ref5$current;

    if (pageData && isLoggedIn && TitleRef !== null && TitleRef !== void 0 && TitleRef.current && Ref1 !== null && Ref1 !== void 0 && (_Ref1$current = Ref1.current) !== null && _Ref1$current !== void 0 && _Ref1$current[1] && Ref2 !== null && Ref2 !== void 0 && Ref2.current && Ref3 !== null && Ref3 !== void 0 && (_Ref3$current = Ref3.current) !== null && _Ref3$current !== void 0 && _Ref3$current[0].current && Ref4 !== null && Ref4 !== void 0 && Ref4.current && Ref6 !== null && Ref6 !== void 0 && Ref6.current && Ref7 !== null && Ref7 !== void 0 && Ref7.current && !preloader) {
      setSecObj([TitleRef.current, Ref1.current[0].current, Ref1.current[1].current, Ref2.current[0].current[0].current, Ref2.current[1].current, Ref2.current[2].current, Ref2.current[3].current, Ref2.current[4].current.childNodes, Ref2.current[5].current, Ref3.current[0].current.childNodes[0].childNodes, Ref3.current[0].current.childNodes[1].childNodes, Ref4.current[0].current.childNodes, Ref6.current[0].current.childNodes, (0,helpers/* arrayGenChild */.YJ)(Ref7.current[0].current.childNodes[0].childNodes), Ref7.current[2].current.childNodes, Ref7.current[3].current]);
    } else if (pageData && !isLoggedIn && TitleRef !== null && TitleRef !== void 0 && TitleRef.current && Ref1 !== null && Ref1 !== void 0 && (_Ref1$current2 = Ref1.current) !== null && _Ref1$current2 !== void 0 && _Ref1$current2[1] && Ref2 !== null && Ref2 !== void 0 && Ref2.current && Ref3 !== null && Ref3 !== void 0 && (_Ref3$current2 = Ref3.current) !== null && _Ref3$current2 !== void 0 && _Ref3$current2[0].current, Ref5 !== null && Ref5 !== void 0 && (_Ref5$current = Ref5.current) !== null && _Ref5$current !== void 0 && _Ref5$current[0]) {
      setSecObj([TitleRef.current, Ref1.current[0].current, Ref1.current[1].current, Ref2.current[0].current[0].current, Ref2.current[1].current, Ref2.current[2].current, Ref2.current[3].current, Ref2.current[4].current.childNodes, Ref3.current[0].current.childNodes[0].childNodes, Ref5.current[0].current.childNodes]);
    }
  }, [TitleRef.current, Ref1.current, Ref2.current, Ref3.current, Ref4.current, Ref5.current, Ref6.current, Ref7.current, pageData, winWidth, preloader]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(pages_SingleInvestmentProjectStyle, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(common/* Page */.T3, {
      className: "single-invest",
      meta: {
        title: pageData === null || pageData === void 0 ? void 0 : (_pageData$project = pageData.project) === null || _pageData$project === void 0 ? void 0 : (_pageData$project$met = _pageData$project.meta) === null || _pageData$project$met === void 0 ? void 0 : _pageData$project$met.title,
        description: pageData === null || pageData === void 0 ? void 0 : (_pageData$project2 = pageData.project) === null || _pageData$project2 === void 0 ? void 0 : (_pageData$project2$me = _pageData$project2.meta) === null || _pageData$project2$me === void 0 ? void 0 : _pageData$project2$me.description,
        keywords: pageData === null || pageData === void 0 ? void 0 : (_pageData$project3 = pageData.project) === null || _pageData$project3 === void 0 ? void 0 : (_pageData$project3$me = _pageData$project3.meta) === null || _pageData$project3$me === void 0 ? void 0 : _pageData$project3$me.keywords,
        image: pageData === null || pageData === void 0 ? void 0 : pageData.project.meta_image
      },
      children: pageData && /*#__PURE__*/(0,jsx_runtime.jsxs)(common/* AnimationWrapp */.dh, {
        state: secObj,
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(common/* Container */.W2, {
          className: "top-container",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(common/* CustomLink */.xb, {
            ref: TitleRef,
            className: "back-to",
            url: "/investment-projects",
            content: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(common/* Icon */.JO, {
                className: "icon-arrow-left ultraDarkGrey"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(common/* Text */.xv, {
                tag: 'p',
                className: 'pM MonRegular ultraDarkGrey',
                text: 'allProjects'
              })]
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "top",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(pages/* Slider */.iR, {
              photos: pageData.project.photos,
              ref: Ref1
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(pages/* ProjectInfo */.vz, {
              ref: Ref2,
              id: pageData.project.id,
              categorySlug: pageData.project.company.category_id.slug,
              categoryName: pageData.project.company.category_id.name,
              title: pageData.project.name,
              location: pageData.project.city.name,
              companyName: pageData.project.company.name,
              companyType: pageData.project.company.type,
              companyURL: helpers/* config.routes.projectsCompanySingle.path.replace */.vc.routes.projectsCompanySingle.path.replace(':slug', pageData.project.company.slug),
              priceDollar: "".concat(pageData.project.required_investment.USD),
              priceDram: "".concat(pageData.project.required_investment.AMD),
              priceDollarFull: "".concat(pageData.project.total_cost.USD),
              priceDramFull: "".concat(pageData.project.total_cost.AMD),
              profitPercent: "".concat(pageData.project.margin_profitability),
              yearlySaleDollar: pageData.project.company.average_sales.USD,
              yearlySaleDram: pageData.project.company.average_sales.AMD,
              auctionsPercent: "".concat(pageData.project.share_company),
              employersNumber: pageData.project.company.employees_number,
              paybackPeriod: pageData.project.payback_period,
              projectPriceTooltip: (_pageData$project4 = pageData.project) === null || _pageData$project4 === void 0 ? void 0 : _pageData$project4.project_price_tooltip,
              loggedIn: isLoggedIn,
              details: (_pageData$project5 = pageData.project) === null || _pageData$project5 === void 0 ? void 0 : _pageData$project5.details
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(pages/* ProjectContent */.Ds, {
              ref: Ref3,
              aboutCompany: pageData.project.company.short_description,
              aboutInvestProject: pageData.project.short_description,
              bussinesPlan: pageData.project.bussines_plan
            })]
          }), isLoggedIn ? /*#__PURE__*/(0,jsx_runtime.jsx)(pages/* MapInSingle */.UY, {
            ref: Ref4,
            latitude: pageData.project.latitude,
            longitude: pageData.project.longitude
          }) : /*#__PURE__*/(0,jsx_runtime.jsx)(pages/* FormForGuest */.Pp, {
            ref: Ref5
          })]
        }), isLoggedIn && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(pages/* ProjectApproved */.d_, {
            ref: Ref6
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(pages/* CatalogView */.N1, {
            ref: Ref7,
            singleInvest: true,
            title: 'youMightInterested',
            catalogsArr: pageData.relatedProjects,
            url: helpers/* config.routes.investmentProjects.path */.vc.routes.investmentProjects.path
          })]
        })]
      })
    })
  });
});
/* harmony default export */ var _slug_ = ((0,context/* withDataContext */.hX)((0,context/* withAccountContext */.R$)((0,context/* withUIContext */.pP)(SingleInvestmentProjects, ['winWidth']), ['isLoggedIn']), ['global', helpers/* config.routes.singleInvestmentProject.singleType */.vc.routes.singleInvestmentProject.singleType]));

/***/ }),

/***/ 85574:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/investment-projects/[slug]",
      function () {
        return __webpack_require__(89594);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [774,888,179], function() { return __webpack_exec__(85574); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);